import React, { memo, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Callout, CopyButton, DataListItem } from '@node-space/ui-components'
import { Options } from 'types/BankAccountsDetails'
import { getSwiftBankDetails, useGetSwiftDetails } from 'utils/wallet'
import useDepositPaymentReference from '../hooks/useDepositPaymentReference'

interface SwiftDetailsProps {
  options: Options
}

const SwiftDetails = ({ options }: SwiftDetailsProps) => {
  const { t } = useTranslation()
  const accountDetails = getSwiftBankDetails(options, t)
  const paymentReference = useDepositPaymentReference(options)

  const details = useGetSwiftDetails(options, t)

  const accountDetailsText = useMemo(() => {
    const allBeneficiaryBankDetailsText = Object.keys(details || {})
      .map(label => `${label}: ${details[label]}`)
      .join('\n')

    return allBeneficiaryBankDetailsText
  }, [details])

  if (!Object.keys(accountDetails).length) {
    return <Callout variant="error">{t('oopsSomethingWentWrongFetchDespoitDetails')}</Callout>
  }

  return (
    <>
      {Object.keys(details)
        .filter(label => !!label)
        .map(label => {
          return (
            <DataListItem
              key={label}
              body={details[label]}
              copyText={details[label]}
              id={label}
              title={label}
            />
          )
        })}
      <Box flexCol justify="center" align="center" paddingT={16}>
        <CopyButton copyText={accountDetailsText}>{t('copyAllDetails')}</CopyButton>
      </Box>

      {!!paymentReference && (
        <Box paddingY={16}>
          <Callout variant="warning">{t('depositInformation')}</Callout>
        </Box>
      )}
    </>
  )
}

export default memo(SwiftDetails)
